import * as datGui from 'dat.gui'
import { wrapFunctionToProp } from './functionToPropWrapper'

type SetupMinMaxValueGUI = {
  folder: datGui.GUI
  updateMinMaxDisplay: (min: number, max: number) => void
  currentValueGUI: datGui.GUIController
}

export function setupMinMaxValueGUI(
  targetFolder: datGui.GUI,
  objName: string,
  minValue: number,
  maxValue: number,
  setMinCallback: (val: number) => void,
  setMaxCallback: (val: number) => void,
  targetFunction: () => number,
): SetupMinMaxValueGUI {
  const objectFolder = targetFolder.addFolder(objName)

  const minMax = {
    min: minValue,
    max: maxValue,
  }
  const targetObject = isFunction(targetFunction)
    ? wrapFunctionToProp(targetFunction).obj
    : targetFunction
  const targetPropName = 'value'
  const curGui = objectFolder
    .add(targetObject as Record<string, unknown>, targetPropName)
    .name('Current value')
    .listen()

  let minGuiOnChangeActive = true
  const minGUI = objectFolder
    .add(minMax, 'min')
    .name('Min value')
    .onChange((val: number) => {
      if (minGuiOnChangeActive) {
        minMax.min = val
        setMinCallback(val)
      }
    })

  let maxGuiOnChangeActive = true
  const maxGUI = objectFolder
    .add(minMax, 'max')
    .name('Max value')
    .onChange((val: number) => {
      if (maxGuiOnChangeActive) {
        minMax.max = val
        setMaxCallback(val)
      }
    })

  const updateMinMaxDisplay = (min: number, max: number) => {
    minGuiOnChangeActive = false
    maxGuiOnChangeActive = false
    minMax.min = min
    minMax.max = max
    minGUI.setValue(min)
    minGUI.updateDisplay()
    maxGUI.setValue(max)
    maxGUI.updateDisplay()
    minGuiOnChangeActive = true
    maxGuiOnChangeActive = true
  }

  return {
    folder: objectFolder,
    updateMinMaxDisplay,
    currentValueGUI: curGui,
  }
}

function isFunction(obj: unknown | (() => number)): obj is () => number {
  return typeof obj === 'function'
}
